import React from "react";
import Navbar from "@/components/smartcontainer/Navbar";
import Hero from "@/components/smartcontainer/Hero";
import ProblemSection from "@/components/smartcontainer/ProblemSection";
import FeaturesSection from "@/components/smartcontainer/FeaturesSection";
import HowItWorks from "@/components/smartcontainer/HowItWorks";
import BuilderShowcase from "@/components/smartcontainer/BuilderShowcase";
import ConnectedWorkspace from "@/components/smartcontainer/ConnectedWorkspace";
import OutcomesSection from "@/components/smartcontainer/OutcomesSection";
import FaqSection from "@/components/smartcontainer/FaqSection";
import FinalCta from "@/components/smartcontainer/FinalCta";
import Footer from "@/components/smartcontainer/Footer";

export default function SmartContainer() {
  return (
    <div className="bg-white text-slate-900 antialiased" data-testid="smartcontainer-page">
      <Navbar />
      <main>
        <Hero />
        <ProblemSection />
        <FeaturesSection />
        <HowItWorks />
        <BuilderShowcase />
        <ConnectedWorkspace />
        <OutcomesSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
